import GalleryGridContainer from "../../../../Components/Miscellaneous/Gallery/GalleryGrid/GalleryGridContainer";

const GalleryGrid = () => {
  return <GalleryGridContainer />;
};

export default GalleryGrid;
